import selectFolderWithFallback from './selectFolderWithFallback';
import selectRow from './selectRow';

export default function selectFolderAndRow(folderId?: string, rowId?: string): void {
    selectFolderWithFallback(folderId);
    if (rowId) {
        selectRow(rowId);
    }
}
